export default "__VITE_ASSET__b976525e__"